import { render, staticRenderFns } from "./entitlement-period-extend.vue?vue&type=template&id=2f16dfba"
import script from "./entitlement-period-extend.vue?vue&type=script&lang=js"
export * from "./entitlement-period-extend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports